/**
 * App mode (sender / driver / center / receiver / company) — mirror of
 * the Flutter `ModeSelectorPage` selection. Persisted to localStorage so
 * the user lands on their preferred dashboard on next visit.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AppMode = 'sender' | 'driver' | 'center' | 'receiver' | 'company';

interface ModeState {
  mode: AppMode | null;
  setMode: (mode: AppMode) => void;
  clear: () => void;
}

export const useModeStore = create<ModeState>()(
  persist(
    (set) => ({
      mode: null,
      setMode: (mode) => set({ mode }),
      clear: () => set({ mode: null }),
    }),
    { name: 'cargo-web-mode' }
  )
);
